import {Component, Input} from '@angular/core';
import {
    meetsPasswordRequirements,
    PasswordRequirementChecks,
    passwordRequirementChecks,
} from '../../infra/password-requirements.validator';

@Component({
    selector: 'af-password-requirements',
    templateUrl: './password-requirements.component.html',
    styleUrls: ['./password-requirements.component.scss'],
    standalone: false,
})
export class PasswordRequirementsComponent {
    @Input() password: string | null = null;
    expanded = false;

    get show(): boolean {
        const value = this.password ?? '';
        return value.length > 0 && !meetsPasswordRequirements(value);
    }

    get checks(): PasswordRequirementChecks {
        return passwordRequirementChecks(this.password ?? '');
    }
}
